// REF: seller::@/views/CmsSetting/constants/Product.js
/** SKU 顯示方式 */
export const SKU_STYLE_TYPE = Object.freeze({
  EXPAND: 'expand',
  COLLAPSE: 'collapse',
});

/** SKU 收合時顯示形狀 */
export const SKU_COLLAPSE_STYLE = Object.freeze({
  SQUARE: 'square',
  CIRCLE: 'circle',
  HIDDEN: 'hidden',
});

export const ARCHIVE_TYPE = Object.freeze({
  RAW: 'raw',
  CHAPTER: 'chapters',
  CLIP: 'clips',
});

export const SALABLE_STATUS = Object.freeze({
  BEFORE_SELL: 'before_sell', // 尚未銷售(就是還不可以買)
  END_SELL: 'end_sell', // 結束銷售(就是不賣了)
  SOLD_OUT: 'sold_out', // 已售完
  ON_SELL: 'on_sell', // 可銷售
});
